import React, { FC } from "react";
import { Hierarchy } from "./entityHierarchy";

const Node: FC<Hierarchy> = ({ label, node }) => {
    return <div className="overflow-hidden">
        {node
            ? <>
                <div className="flex flex-row ml-0-5 overflow-hidden">
                    <div className="border-r-2 border-tree-grey"></div>
                    <div className="w-2 border-t-2 my-auto border-tree-grey"></div>
                    <div className="w-2 h-2 bg-tree-grey my-auto"></div>
                    <div className="ml-2 bound-title overflow-hidden">{label}</div>
                </div>
                <div className="ml-3">
                    <Node label={node.label} node={node.node}></Node>
                </div></>
            :
            <div className="flex flex-row ml-0-5 overflow-hidden">
                <div className="border-r-2 border-tree-grey"></div>
                <div className="w-2 border-t-2 my-auto border-tree-grey "></div>
                <div className="w-2 h-2 bg-portal-blue-primary-shade2 my-auto "></div>
                <div className="ml-2 bound-title">{label}</div>
            </div>}
    </div>;
};

export default Node;
